import axios from "axios";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";
import AdminAutoComplete from "../AdminAutoComplete";

const EditSubAdmin = (props) => {
    document.title = "DirtMap - Edit Sub Admin";

    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [userInput, setUserInput] = useState([]);
    const [error, setError] = useState([]);
    const [addressLocation, setAddressLocation] = useState();

    const [loader, showLoader, hideLoader] = UseFullPageLoader();

    const [isDisplayed, setIsDisplayed] = useState(false);


    useEffect(() => {
        setInterval(() => {
            setIsDisplayed(true);
        }, 1200);
      }, []);
      
  
      const setCoodinationValueAddress = (results, ll) => {
        // console.log(results);
         //userInput.street_address = results;
         var street1 = "", street2 = "", city = "", state = "", zip = "", country = "";
         for (var i = 0; i < results[0].address_components.length; i++) {
             for (var j = 0; j < results[0].types.length; j++) {
                 if (results[0].address_components[i].types[j] === "street_number" || results[0].address_components[i].types[j] === "sublocality_level_1")
                     street1 = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "route" || results[0].address_components[i].types[j] === "sublocality_level_2")
                     street2 = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "locality")
                     city = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "administrative_area_level_1" || results[0].address_components[i].types[j] === "administrative_area_level_2")
                     state = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "postal_code")
                     zip = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
                 if (results[0].address_components[i].types[j] === "country")
                     // country = results[0].address_components[i].short_name
                     country = results[0].address_components[i].long_name != '' ? results[0].address_components[i].long_name : '';
             }
         }
 
         // console.log(street1);
         // console.log(street2);
         // console.log(city);
         // console.log(state);
         // console.log(zip);
         // console.log(country);
 
         //  $("input[name=street_address]").val(street1 + ' ' + street2);
         //  $("input[name=city]").val(city);
         //  $("input[name=state]").val(state);
         //  $("input[name=postal_code]").val(zip);
 
         //userInput.street_address_2 = value;
         document.getElementById("__postSearchLocationAdress").value = street1;
         document.getElementById("__postSearchLocationAdress2").value = street2;
         document.getElementById("__postSearchLocationCity").value = city;
         document.getElementById("__postSearchLocationState").value = state;
 
         document.getElementById("__postLatitude").value = ll.lat;
         document.getElementById("__postLongitude").value = ll.lng;

         userInput.street_address = street1;
         userInput.street_address_2 = street2;
         userInput.city = city;
         userInput.state = state;
         userInput.latitude = ll.lat;
         userInput.longitude = ll.lng;
 
         //street_address_2
 
     }
 
    const handleInput = (e) => {
        e.persist();
        setUserInput({ ...userInput, [e.target.name]: e.target.value });
    }

    useEffect(() => {
        const userId = props.match.params.id;

        axios.get(`api/get/profile/${userId}`).then(res => {
            console.log(res.data.success);
            if (res.data.result) {
                setUserInput(res.data.result);
                setAddressLocation(res.data.result);
            } else if (res.data.success === false) {
                swal("warning", res.data.message, "error");
                history.push('/admin/sub-admin/index');
            }
            setLoading(false);
        });

    }, [props.match.params.id, history]);

    if (loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;

    } 

    const updateUser = (e) => {
        e.preventDefault();
        const userId = props.match.params.id;
        const data = userInput;
        showLoader();
        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post(`/api/update/profile/${userId}`, data).then(res => {
                if (res.data.result) {
                    hideLoader();
                    swal("success", "User Updated Successfully Done", "success");
                    setError([])
                    history.push('/admin/sub-admin/index');
                }
                else {
                    hideLoader();
                    setError(res.data.errors);
                }
            });
        });
    }


    return (
        <div className="container-fluid">
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h4 className="card-title mb-0">Edit Sub Admin</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={updateUser}>
                    <input type="hidden" id="__postSearchLocationAdress" name="street_address" onChange={handleInput} value={userInput.street_address} />
                    <input type="hidden" id="__postLatitude" name="latitude" onChange={handleInput} value={userInput.latitude} />
                    <input type="hidden" id="__postLongitude" name="longitude" onChange={handleInput} value={userInput.longitude} />
    
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">First Name</label>
                                    <input type="text" name="first_name" onChange={handleInput} value={userInput.first_name} className="form-control" placeholder="Enter First Name" />
                                    <span className="validate-error-message">{error.first_name}</span>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">Last Name</label>
                                    <input type="text" name="last_name" onChange={handleInput} value={userInput.last_name} className="form-control" placeholder="Enter Last Name" />
                                    <span className="validate-error-message">{error.last_name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="userName">User Name</label>
                                    <input type="text" name="user_name" onChange={handleInput} value={userInput.user_name} className="form-control" placeholder="Enter User Name" />
                                    <span className="validate-error-message">{error.user_name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" name="email" onChange={handleInput} value={userInput.email} className="form-control" placeholder="Enter Email" />
                                    <span className="validate-error-message">{error.email}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="companyName">Company Name</label>
                                    <input type="text" name="company_name" onChange={handleInput} value={userInput.company_name} className="form-control" placeholder="Enter Company Name" />
                                    <span className="validate-error-message">{error.company_name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="streetAddress">Street Address</label>
                                    {/* <input type="text" name="street_address" onChange={handleInput} value={userInput.street_address} className="form-control" placeholder="Enter Street Address" /> */}
                                    {isDisplayed &&
                                        <AdminAutoComplete
                                        apiKey={'AIzaSyCv7m-2LTrrKnu1P38xKNBvvFJXoQGAnGg'}
                                        setCoodinationValueAddress={setCoodinationValueAddress}
                                        addressLocation={addressLocation}
                                        />
                                    } 
                                    
                                    <span className="validate-error-message">{error.street_address}</span>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="streetAddress2">Street Address 2</label>
                                    <input type="text" id="__postSearchLocationAdress2" name="street_address_2" onChange={handleInput} value={userInput.street_address_2} className="form-control" placeholder="Enter Street Address 2" />
                                 
                                    <span className="validate-error-message">{error.street_address_2}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="City">City</label>
                                    <input type="text" id="__postSearchLocationCity" name="city" onChange={handleInput} value={userInput.city} className="form-control" placeholder="Enter City" />
                                
                                    <span className="validate-error-message">{error.city}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="State">State</label>
                                    <input type="text" id="__postSearchLocationState" name="state" onChange={handleInput} value={userInput.state} className="form-control" placeholder="Enter State" />
                                  
                                    <span className="validate-error-message">{error.state}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="phoneNumber">Phone Number</label>
                                    <input type="text" name="phone_number" onChange={handleInput} value={userInput.phone_number} className="form-control" placeholder="Enter Phone Number" />
                                    <span className="validate-error-message">{error.phone_number}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-md-12 text-right">
                                <button type="submit" className="btn btn-primary">Update</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {loader}
        </div>
    );
}
export default EditSubAdmin;